import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  CustomButton,
  StyledCard,
  StyledOutlineButton,
  VendorCardLabel,
} from "../../vendorRegistration/components/StepMain";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  // Pagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { VendorCardTitle } from "../../adminOrders/components/adminOrdersViewContent";
import {
  Super,
  VendorCardSubTitle,
} from "../../vendorRegistration/components/steps/cardTrial";
import {
  CustomTableContainer,
  TableContentFont,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import { Delete, RemoveRedEye } from "@mui/icons-material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { styled } from "@mui/system";
import { LoadingButton } from "@mui/lab";
import {
  createArn,
  getAdminArns,
  // getArnTokenValid,
} from "../redux/adminArnsSlice";
// import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../../app/history";

const Input = styled("input")({
  display: "none",
});
function AdminArnsContent() {
  const [quntityValue, setQuntityValue] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [viewItemDetails, setViewItemDetails] = useState(null);
  const [documentsList, setDocumentsList] = useState([]);
  const [documents, setDocuments] = useState("");
  const [deleteDocModal, setDeleteDocModal] = useState(false);
  const [documentItemDetails, setDocumentItemDetails] = useState(null);
  const [addUploadDocumentModalOpen, setAddUploadDocumentModalOpen] =
    useState(false);
  const [inputValue, setInputValue] = useState(null);
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token");
  const dispatch = useDispatch();
  const { loading, arn_details, create_arn_loading } = useSelector(
    (state) => state.adminArns
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const viewItemFields = [
    { label: "ITEM CODE", key: "MaterialCode" },
    { label: "ITEM NAME", key: "Description" },
    { label: "ASN QUANTITY", key: "quantity" },
    { label: "PO QUANTITY", key: "quantity" },
    { label: "ITEM DESCRIPTION", key: "item_description" },
    // { label: "RATE", key: "unit_price" },
    // { label: "DISCOUNT IN %", key: "discount" },
    { label: "UOM", key: "uom" },
    { label: "LOCATION", key: "location" },
    // { label: "GST TYPE", key: "gst_type" },
    // { label: "GST IN %", key: "gst_per" },
    // { label: "ITEM TOTAL AMOUNT", key: "unit_total_price" },
    { label: "DATE OF DELIVERY", key: "delievery_date" },
  ];

  const documentListColumns = [
    { key: "srNo", label: "Sr. No." },
    { key: "doc_title", label: "Document Title" },
    { key: "name", label: "Documents" },
  ];

  const itemColumns = [
    { key: "id", label: "Sr. No." },
    { key: "MaterialCode", label: "Item Code" },
    { key: "Description", label: "Item Name" },
    { key: "quantity", label: "PO Quantity" },
    // { key: "remaining_quantity", label: "Remaining Quantity" },
    { key: "uom", label: "UOM" },
    // { key: "unit_price", label: "Rate" },
    { key: "quantity", label: "ASN Quantity" },
    { key: "accpected_quantity", label: "Accepted Quantity" },
    { key: "rejected_quantity", label: "Rejected Quantity" },
    { key: "remarks", label: "Remarks" },
    { key: "action", label: "Action" },
  ];

  const handleQuantityChange = (event, fieldName, id) => {
    const value = event === "" ? "" : Number(event);
    setQuntityValue((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [fieldName]: value,
      },
    }));
  };
  const handleInputChange = (event, fieldName, id) => {
    const { value } = event.target;
    setInputValue((prev) => ({
      ...prev,
      [id]: {
        ...prev?.[id],
        [fieldName]: value,
      },
    }));
  };
  const handleViewModalOpen = (itemID) => {
    setViewModal(true);
    if (itemID) {
      const item = arn_details?.AsnMaterials?.find(
        (item) => item?.id === itemID
      );
      setViewItemDetails(item);
    }
  };
  const handleViewModalClose = () => {
    setViewModal(false);
    setViewItemDetails(null);
  };
  const handleClose = (closeType) => {
    if (closeType === "inClose" || closeType === "outClose") {
      const userConfirmed = window.confirm(
        "Your entered item data will be lost. Do you want to close the dialog box?"
      );
      if (userConfirmed) {
        setDocumentItemDetails(null);
        setDocuments("");
      }
    }
    if (closeType === "uploadDocument") {
      setAddUploadDocumentModalOpen(false);
      setDocumentItemDetails(null);
      setDocuments("");
    }
  };
  const handleDocModalOpen = (itemID, type) => {
    setDeleteDocModal(type);
    if (itemID !== null || itemID !== undefined || itemID !== "") {
      setDocumentItemDetails(itemID);
    }
  };
  const handleAddUploadDocumentModal = () => {
    setAddUploadDocumentModalOpen(true);
  };
  const handleAddDocumentData = () => {
    setDocumentsList([
      ...documentsList,
      {
        ...documentItemDetails,
        file: documents,
      },
    ]);
    handleClose("uploadDocument");
  };
  const handleChange = (event, type) => {
    const { name, value } = event.target;
    if (type === "doc_title") {
      setDocumentItemDetails((prev) => {
        const updatedDetails = {
          ...prev,
          [name]: value,
        };
        return updatedDetails;
      });
    }
  };
  const handleDeleteTerms = () => {
    if (deleteDocModal === "uploadDocument") {
      const updatedItems = documentsList?.filter(
        (item, index) => index !== documentItemDetails
      );
      setDocumentsList(updatedItems);
      handleDeleteDocModalClose();
    }
  };
  const handleDeleteDocModalClose = () => {
    setDeleteDocModal(false);
    setDocumentItemDetails(null);
  };
  const handleSave = (asn_details) => {
    const apiPayload = {
      asn_number: asn_details?.asn_number,
      token: token,
      items: arn_details?.AsnMaterials.map((sub_item, index) => ({
        asn_item_id: sub_item?.id,
        accepted_quantity: quntityValue?.[sub_item?.id]?.accepted_quantity,
        rejected_quantity: quntityValue?.[sub_item?.id]?.rejected_quantity,
        remark: inputValue?.[sub_item?.id]?.remarks,
      })),
      arn_documents_name: documentsList?.map((doc) => ({
        document_title: doc?.doc_title,
        docs_name: doc?.file?.name,
      })),
    };
    var formData = new FormData();
    formData.append("data", JSON.stringify(apiPayload));
    for (let i = 0; i < documentsList?.length; i++) {
      formData.append("arn_documents", documentsList[i]?.file);
    }
    dispatch(createArn(formData)).then((response) => {
      if (response?.payload?.success) {
        history.push("/login");
      }
    });
  };
  const getArnInitialData = (token) => {
    dispatch(getAdminArns(token));
  };

  useEffect(() => {
    getArnInitialData(token);
    // eslint-disable-next-line
  }, []);

  const isButtonDisabled = useMemo(() => {
    if (!arn_details?.AsnMaterials) return true;
    return arn_details?.AsnMaterials?.some((item) => {
      const acceptedQuantity = quntityValue[item.id]?.accepted_quantity || 0;
      const rejectedQuantity = quntityValue[item.id]?.rejected_quantity || 0;

      return acceptedQuantity + rejectedQuantity !== Number(item?.quantity);
    });
  }, [arn_details, quntityValue]);

  return (
    <>
      <Dialog
        open={viewModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
        onClose={handleViewModalClose}
      >
        <DialogTitle id="alert-dialog-title">
          {`Item #${viewItemDetails?.OrderMaterial?.MaterialMaster?.MaterialCode}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid container spacing={4}>
              {viewItemDetails &&
                viewItemFields.map((field) => (
                  <Grid
                    item
                    xs={field?.label === "ITEM DESCRIPTION" ? 12 : 3}
                    md={field.label === "ITEM DESCRIPTION" ? 12 : 3}
                  >
                    <Typography className="label">{field.label}</Typography>
                    <VendorCardLabel>
                      {field.formatter
                        ? field.formatter(viewItemDetails[field.key])
                        : field.label === "ASN QUANTITY"
                        ? viewItemDetails?.[field.key]
                        : field.key === "MaterialCode" ||
                          field.key === "Description"
                        ? viewItemDetails?.OrderMaterial?.MaterialMaster?.[
                            field.key
                          ]
                        : viewItemDetails?.OrderMaterial?.[field.key]}
                    </VendorCardLabel>
                  </Grid>
                ))}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleViewModalClose}
            variant="outlined"
            style={{
              borderColor: "var(--button-color)",
              color: "black",
            }}
            size="small"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteDocModal === "uploadDocument" ? true : false}
        onClose={handleDeleteDocModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Please Confirm"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to remove this document?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDeleteDocModalClose}
            variant="outlined"
            style={{
              borderColor: "red",
              color: "black",
            }}
            size="small"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              float: "right",
              // backgroundColor: "var(--button-color)",
              color: "white",
            }}
            color="error"
            onClick={handleDeleteTerms}
            autoFocus
            size="small"
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={addUploadDocumentModalOpen}
        onClose={(e) => handleClose("outClose")}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter Upload Document Details"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={6}>
            <Grid item md={4}>
              <VendorCardSubTitle>Title</VendorCardSubTitle>
              <TextField
                sx={{
                  input: {
                    fontSize: "14px",
                    fontFamily: "var(--font-family-reg)",
                  },
                }}
                placeholder="Enter Title"
                type="text"
                size="small"
                variant="standard"
                style={{ width: "100%", paddingTop: "3px" }}
                name="doc_title"
                value={documentItemDetails?.doc_title ?? ""}
                onChange={(e) => {
                  handleChange(e, "doc_title");
                }}
              />
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "end" }}>
              {documents !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(–font-family-reg)",
                    }}
                  >
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        // margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={documents.name}
                      value={documents.name}
                      name="chips"
                    />
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setDocuments("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="dealer">
                  <Input
                    accept="*"
                    id="dealer"
                    name="dealer"
                    onChange={(e) => setDocuments(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{documents.name}</span>
                </label>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => handleClose("uploadDocument")}
            variant="outlined"
            style={{
              borderColor: "var(--button-color)",
              color: "black",
            }}
            size="small"
          >
            Close
          </Button>
          <Button
            variant="contained"
            style={{
              float: "right",
              backgroundColor: "success",
              color: "white",
            }}
            onClick={handleAddDocumentData}
            autoFocus
            size="small"
          >
            {"Add"}
          </Button>
        </DialogActions>
      </Dialog>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "20px",
            paddingBottom: "20px",
          }}
        >
          <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
        </Box>
      ) : (
        <form onSubmit={handleSubmit(handleSave)}>
          <StyledCard>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item md={6}>
                  <VendorCardTitle style={{ paddingBottom: "0" }}>
                    Create New Accepted & Rejected Quantity Notes
                  </VendorCardTitle>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item md={8}>
                  <VendorCardSubTitle style={{ marginTop: "0" }}>
                    Enter ARN details
                  </VendorCardSubTitle>
                </Grid>
              </Grid>
              <br />
              <Grid container spacing={3}>
                <Grid item md={6}>
                  <VendorCardLabel>
                    PO Number<Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Enter PO Number"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    value={arn_details?.Order?.order_number}
                    name="po_number"
                    {...register("po_number", {
                      required: "Please Enter PO Number",
                      value: arn_details?.Order?.order_number,
                    })}
                    disabled
                    error={Boolean(errors?.po_number)}
                    helperText={errors?.po_number?.message}
                  />
                </Grid>
                <Grid item md={6}>
                  <VendorCardLabel>
                    ASN Number<Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Enter ASN Number"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    value={arn_details?.asn_number}
                    name="asn_number"
                    {...register("asn_number", {
                      required: "Please Enter ASN Number",
                      value: arn_details?.asn_number,
                    })}
                    disabled
                    error={Boolean(errors?.asn_number)}
                    helperText={errors?.asn_number?.message}
                  />
                </Grid>
              </Grid>
              <br />
              <br />
              <VendorCardTitle>Item Details</VendorCardTitle>
              {arn_details?.AsnMaterials?.length ? (
                <CustomTableContainer component={Card}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow
                        style={{
                          backgroundColor: "#e1ebfa",
                        }}
                      >
                        {itemColumns.map((column, index) => (
                          <TableCell
                            key={index}
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            {column?.label}{" "}
                            {column?.label === "Remarks" && <Super>*</Super>}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {arn_details?.AsnMaterials?.map((item, index) => (
                        <TableRow
                          key={index}
                          style={{
                            backgroundColor: "#fafcff",
                          }}
                        >
                          {itemColumns.map((column) => (
                            <>
                              <TableCell
                                key={column.key}
                                style={{
                                  fontFamily: "var(--font-family-reg)",
                                  fontSize: "12px",
                                  textAlign: column.align || "left",
                                  color:
                                    column?.key === "Description"
                                      ? "#0000FF"
                                      : "inherit",
                                }}
                              >
                                {column?.key === "srNo" ? (
                                  index + 1
                                ) : column?.key === "action" ? (
                                  <Tooltip title="View Item">
                                    <IconButton aria-label="view">
                                      <RemoveRedEye
                                        style={{
                                          fill: "royalblue",
                                          height: "18px",
                                          width: "18px",
                                        }}
                                        onClick={() =>
                                          handleViewModalOpen(item?.id)
                                        }
                                      />
                                    </IconButton>
                                  </Tooltip>
                                ) : column?.key === "Description" ? (
                                  <Tooltip
                                    arrow
                                    title={
                                      item?.OrderMaterial?.item_description ||
                                      "No description available"
                                    }
                                  >
                                    <span>
                                      {
                                        item?.OrderMaterial?.MaterialMaster?.[
                                          column?.key
                                        ]
                                      }
                                    </span>
                                  </Tooltip>
                                ) : column?.key === "accpected_quantity" ? (
                                  <TableContentFont>
                                    <TextField
                                      sx={{
                                        input: {
                                          fontSize: "14px",
                                          fontFamily: "var(--font-family-reg)",
                                        },
                                      }}
                                      required
                                      placeholder="Enter Accepted Quantity"
                                      size="small"
                                      type="number"
                                      variant="outlined"
                                      style={{
                                        width: "100%",
                                        paddingTop: "3px",
                                      }}
                                      value={
                                        quntityValue[item.id]
                                          ?.accepted_quantity ?? ""
                                      }
                                      name="accepted_quantity"
                                      onChange={(e) => {
                                        const inputValue = e.target.value;
                                        const value =
                                          inputValue === ""
                                            ? ""
                                            : Math.max(0, inputValue);
                                        handleQuantityChange(
                                          value,
                                          "accepted_quantity",
                                          item.id,
                                          item.itemCode
                                        );
                                      }}
                                      error={
                                        quntityValue[item.id]
                                          ?.accepted_quantity !== undefined &&
                                        quntityValue[item.id]
                                          ?.rejected_quantity !== undefined &&
                                        quntityValue[item.id]
                                          ?.accepted_quantity +
                                          quntityValue[item.id]
                                            ?.rejected_quantity !==
                                          Number(item?.quantity) &&
                                        quntityValue[item.id]
                                          ?.accepted_quantity !== "" &&
                                        quntityValue[item.id]
                                          ?.rejected_quantity !== ""
                                      }
                                      helperText={
                                        quntityValue[item.id]
                                          ?.accepted_quantity !== undefined &&
                                        quntityValue[item.id]
                                          ?.rejected_quantity !== undefined &&
                                        quntityValue[item.id]
                                          ?.accepted_quantity +
                                          quntityValue[item.id]
                                            ?.rejected_quantity !==
                                          Number(item?.quantity) &&
                                        quntityValue[item.id]
                                          ?.accepted_quantity !== "" &&
                                        quntityValue[item.id]
                                          ?.rejected_quantity !== ""
                                          ? "Accepted quantity + rejected quantity should be equal to physical quantity received"
                                          : ""
                                      }
                                      //   value={""}
                                    />
                                  </TableContentFont>
                                ) : column?.key === "rejected_quantity" ? (
                                  <TableContentFont>
                                    <TextField
                                      sx={{
                                        input: {
                                          fontSize: "14px",
                                          fontFamily: "var(--font-family-reg)",
                                        },
                                      }}
                                      required
                                      placeholder="Enter Rejected Quantity"
                                      size="small"
                                      type="number"
                                      variant="outlined"
                                      style={{
                                        width: "100%",
                                        paddingTop: "3px",
                                      }}
                                      value={
                                        quntityValue[item.id]
                                          ?.rejected_quantity ?? ""
                                      }
                                      name="rejected_quantity"
                                      onChange={(e) => {
                                        const inputValue = e.target.value;
                                        const value =
                                          inputValue === ""
                                            ? ""
                                            : Math.max(0, inputValue);
                                        handleQuantityChange(
                                          value,
                                          "rejected_quantity",
                                          item.id,
                                          item.itemCode
                                        );
                                      }}
                                      error={
                                        quntityValue[item.id]
                                          ?.accepted_quantity !== undefined &&
                                        quntityValue[item.id]
                                          ?.rejected_quantity !== undefined &&
                                        quntityValue[item.id]
                                          ?.accepted_quantity +
                                          quntityValue[item.id]
                                            ?.rejected_quantity !==
                                          Number(item?.quantity) &&
                                        quntityValue[item.id]
                                          ?.accepted_quantity !== "" &&
                                        quntityValue[item.id]
                                          ?.rejected_quantity !== ""
                                      }
                                      helperText={
                                        quntityValue[item.id]
                                          ?.accepted_quantity !== undefined &&
                                        quntityValue[item.id]
                                          ?.rejected_quantity !== undefined &&
                                        quntityValue[item.id]
                                          ?.accepted_quantity +
                                          quntityValue[item.id]
                                            ?.rejected_quantity !==
                                          Number(item?.quantity) &&
                                        quntityValue[item.id]
                                          ?.accepted_quantity !== "" &&
                                        quntityValue[item.id]
                                          ?.rejected_quantity !== ""
                                          ? "Accepted quantity + rejected quantity should be equal to physical quantity received"
                                          : ""
                                      }
                                      //   value={""}
                                    />
                                  </TableContentFont>
                                ) : column?.key === "remarks" ? (
                                  <TableContentFont>
                                    <TextField
                                      sx={{
                                        "& .MuiInputBase-input": {
                                          fontSize: "14px",
                                          fontFamily: "var(--font-family-reg)",
                                        },
                                      }}
                                      required
                                      placeholder="Enter Remarks"
                                      size="small"
                                      type="text"
                                      variant="outlined"
                                      style={{
                                        width: "100%",
                                        paddingTop: "3px",
                                      }}
                                      // value={
                                      //   inputValue?.[item?.id]?.remarks ?? ""
                                      // }
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          "remarks",
                                          item?.id
                                        )
                                      }
                                    />
                                  </TableContentFont>
                                ) : column?.label === "ASN Quantity" ? (
                                  item?.[column?.key]
                                ) : column?.label === "Item Code" ? (
                                  item?.OrderMaterial?.MaterialMaster?.[
                                    column?.key
                                  ]
                                ) : item?.OrderMaterial?.[column?.key] ? (
                                  item?.OrderMaterial?.[column?.key]
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                            </>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {/* <Grid
                  container
                  className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
                  sx={{ height: "8vh", borderTop: "1px solid lightgray" }}
                >
                  <Grid className="d-flex align-items-center gap-2">
                    <span>Rows per page: </span>
                    <select
                      value={perPage}
                      onChange={(e) => setPerPage(e.target.value)}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </Grid>
                  <Pagination
                    sx={{
                      width: "max-content",
                    }}
                    color="primary"
                    variant="text"
                    onChange={(_, newValue) => setPage(newValue)}
                    count={1}
                    page={page}
                    shape="rounded"
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    showFirstButton
                    showLastButton
                  />
                </Grid> */}
                </CustomTableContainer>
              ) : (
                <Typography className="label">
                  No item added yet. Start by adding an item.
                </Typography>
              )}
            </CardContent>
          </StyledCard>
          <StyledCard>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item md={6}>
                  <VendorCardTitle>Upload Document</VendorCardTitle>
                </Grid>
                <Grid item md={6} style={{ textAlign: "right" }}>
                  <Tooltip title={"Add Upload Document"}>
                    <CustomButton
                      size="small"
                      color="primary"
                      variant="outlined"
                      onClick={handleAddUploadDocumentModal}
                      className="invoiceErrbutn"
                      style={{ marginTop: "10px " }}
                    >
                      Add Upload Document
                    </CustomButton>
                  </Tooltip>
                </Grid>
              </Grid>

              {documentsList?.length ? (
                <CustomTableContainer component={Card}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow
                        style={{
                          backgroundColor: "#e1ebfa",
                        }}
                      >
                        {documentListColumns.map((column, index) => (
                          <TableCell
                            key={index}
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            {column?.label}
                          </TableCell>
                        ))}
                        <TableCell>
                          <TableHeaderFont>Action</TableHeaderFont>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {documentsList.map((item, index) => (
                        <TableRow
                          key={index}
                          style={{
                            backgroundColor: "#fafcff",
                          }}
                        >
                          {documentListColumns.map((column) => (
                            <>
                              <TableCell
                                key={column.key}
                                style={{
                                  fontFamily: "var(--font-family-reg)",
                                  fontSize: "12px",
                                  textAlign: column.align || "left",
                                }}
                              >
                                {column?.key === "srNo"
                                  ? index + 1
                                  : column.key === "name"
                                  ? item?.file?.[column?.key]
                                  : item[column?.key]
                                  ? item[column?.key]
                                  : "-"}
                              </TableCell>
                            </>
                          ))}
                          <TableCell
                            sx={{
                              display: "flex",
                              gap: 1,
                            }}
                          >
                            <Tooltip title="Delete Item">
                              <IconButton aria-label="delete">
                                <Delete
                                  style={{
                                    fill: "royalblue",
                                    height: "18px",
                                    width: "18px",
                                  }}
                                  onClick={() =>
                                    handleDocModalOpen(index, "uploadDocument")
                                  }
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CustomTableContainer>
              ) : (
                <Typography className="label">
                  No document added yet. Start by adding an document.
                </Typography>
              )}
            </CardContent>
          </StyledCard>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              pt: 2,
              justifyContent: "space-between",
              paddingInline: "16px",
            }}
          >
            <Box sx={{ flex: "1 1 auto" }} />
            <LoadingButton
              sx={{
                textTransform: "none",
                background: "#4059e5",
                width: "200px",
                height: "40px",
              }}
              color="primary"
              variant="contained"
              type="submit"
              loading={create_arn_loading}
              disabled={isButtonDisabled}
              loadingPosition="start"
            >
              Submit
            </LoadingButton>
          </Box>
        </form>
      )}
    </>
  );
}

export default AdminArnsContent;
